/* Desertspotter theme — light enhancements */
(function(){
  // Mobile nav (toggle handled inline; close on resize)
  window.addEventListener('resize', function(){
    if (window.innerWidth > 900) {
      var n = document.getElementById('mobileNav');
      if (n) n.classList.remove('open');
    }
  });

  // Product gallery: clicking a thumbnail swaps the main image
  document.addEventListener('click', function(e){
    var t = e.target.closest('.thumbs .t');
    if (!t) return;
    var main = document.querySelector('.gallery .main img');
    var img = t.querySelector('img');
    if (main && img) { main.src = img.src; }
    document.querySelectorAll('.thumbs .t').forEach(function(x){ x.classList.remove('sel'); });
    t.classList.add('sel');
  });

  // Size pills (visual selection mirrors the radio)
  document.addEventListener('change', function(e){
    if (e.target.matches('.size-list input')) {
      e.target.closest('.size-list').querySelectorAll('label').forEach(function(l){ l.classList.remove('sel'); });
      var lbl = document.querySelector('label[for="'+e.target.id+'"]');
      if (lbl) lbl.classList.add('sel');
    }
    if (e.target.matches('.color-list input')) {
      e.target.closest('.color-list').querySelectorAll('.sw').forEach(function(s){ s.classList.remove('sel'); });
      var sw = e.target.parentNode.querySelector('.sw');
      if (sw) sw.classList.add('sel');
    }
  });

  // Variant picker: match selected options -> variant, update id + price + availability
  function money(cents){
    try { return (cents/100).toLocaleString(undefined,{style:'currency',currency: (window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}); }
    catch(e){ return '$' + (cents/100).toFixed(2); }
  }
  document.querySelectorAll('.variant-form').forEach(function(form){
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.parentNode.querySelector('.js-price') || document.querySelector('.js-price');
    var addBtn = form.querySelector('[name="add"]');
    function update(){
      var chosen = [].slice.call(form.querySelectorAll('input[data-opt]:checked'))
        .sort(function(a,b){ return a.dataset.pos - b.dataset.pos; })
        .map(function(i){ return i.value; });
      var match = variants.find(function(v){
        return JSON.stringify(v.options) === JSON.stringify(chosen);
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn){
        if (match.available){ addBtn.disabled = false; addBtn.textContent = 'Add to cart'; addBtn.style.opacity = 1; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; addBtn.style.opacity = .5; }
      }
    }
    form.addEventListener('change', update);
  });
})();
